import { render } from "./MaterialsDevices.vue?vue&type=template&id=63902632"
import script from "./MaterialsDevices.vue?vue&type=script&lang=js"
export * from "./MaterialsDevices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__